export default "__VITE_ASSET__BoREM0oB__"